import qs from 'qs';

const ShopEmployeePosition = {
    namespaced: true,

    state: {
        shopEmployeePositionData: [],
    },

    getters: {
        shopEmployeePositionData (state) {
            return state.shopEmployeePositionData;
        },
    },

    mutations: {

        /**
         * Установить значение должности
         * @param state
         * @param items
         */
        setArr (state, { items }) {
            state['shopEmployeePositionData'] = items;
        },

        /**
         * Обновить значение элемента должности
         * @param state
         * @param item
         * @param index
         */
        setItem (state, { item, index }) {
            state['shopEmployeePositionData'][index] = item;
        },

        /**
         * Добавить значение элемента должности
         * @param state
         * @param item
         */
        addItem (state, { item }) {
            state['shopEmployeePositionData'].push(item);
        },

        /**
         * Удалить элемент из должности
         * @param state
         * @param item
         */
        remove (state, { item }) {
            state['shopEmployeePositionData'] = state['shopEmployeePositionData'].filter(iItem => iItem !== item);
        },
    },


    actions: {

        /**
         * Получение данных по должностям
         * @param commit
         * @param dispatch
         * @param getters
         * @param rootGetters
         * @returns {Promise<any>}
         */
        getShopEmployeePositionData ({ commit, dispatch, getters, rootGetters }) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root:true});
                axios({
                    url: rootGetters.rootUrl +  'list/index',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'token': this.getters['auth/getToken'],
                        'service': rootGetters.service.shopEmployeePosition,
                    }),
                }).then(response => (
                    commit('setArr', {
                        items: response.data
                    }),
                    dispatch('loading/isLoading', false, {root:true}),
                    window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Данные по должностям получены.'),
                    resolve(response)
                )).catch(err => {
                    dispatch('loading/isLoading', false, {root:true}),
                    console.log('ERROR IN shopEmployeePosition.js | getShopEmployeePositionData: ' + err);
                    window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка в получении данных по должностям!'),
                    reject(err);
                });
            })
        },

        /**
         * Сохранение данных по должностям
         * @param commit
         * @param data
         * @returns {Promise<any>}
         */
        saveShopEmployeePositionData ({ commit, dispatch, getters, rootGetters }, data) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root:true});

                const str = JSON.stringify(data.data);

                console.log(str);
                return
                axios({
                    url: rootGetters.rootUrl + 'list/save',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'data': str,
                        'token': this.getters['auth/getToken'],
                        'service': rootGetters.service.shopEmployeePosition,
                    }),
                }).then(response => {
                    console.log(response.data);
                    // Если редактирование
                    if (data.index !== -1) {
                        commit('setItem', {
                            item: data.data,
                            index: data.index
                        });
                        dispatch('loading/isLoading', false, {root:true});
                        window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Должность успешно отредактирована!');

                    // Если сохранение нового
                    } else {
                      data.data.positionId = response.data[0].positionId;
                        commit('addItem', {
                            item: data.data
                        });
                        dispatch('loading/isLoading', false, {root:true});
                        window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Новая должность успешно создана!');
                    }
                    resolve(response);
                }).catch(err => {
                        dispatch('loading/isLoading', false, {root:true});
                        window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка при сохранении данных!');
                        console.log('ERROR IN shopEmployeePosition.js | saveShopEmployeePositionData: ' + err);
                        reject(err);
                });
            })
        },

        /**
         * Удаление должности
         * @param commit
         * @param data
         * @returns {Promise<any>}
         */
        removeShopEmployeePositionData ({ commit, dispatch, getters, rootGetters }, data) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root:true});

                const str = JSON.stringify(data.item);

                console.log(str);
                return

                axios({
                    url: rootGetters.rootUrl + 'list/delete',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'data': str,
                        'token': this.getters['auth/getToken'],
                        'service': rootGetters.service.shopEmployeePosition,
                    }),
                }).then(response => (
                    commit('remove', {
                        item: data.item
                    }),
                    dispatch('loading/isLoading', false, {root:true}),
                    window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Должность успешно удалена!'),
                    resolve(response)
                )).catch(err => {
                    dispatch('loading/isLoading', false, {root:true});
                    window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка при удалении должности!'),
                    console.log('ERROR IN shopEmployeePosition.js | removeShopEmployeePositionData: ' + err);
                    reject(err);
                });
            })
        },
    },
};

export default ShopEmployeePosition;





// WEBPACK FOOTER //
// ./src/store/modules/shopEmployeePosition.js